import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger";
const gsapDocumentItems = document.querySelectorAll('.c-document-types .document-item');
const prefersReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

// If user doesn't prefer reduced motion then add scrolling opacity animation scrubbing
if (!prefersReducedMotion) {
    for (const docItem of gsapDocumentItems) {
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: docItem,
          toggleActions: 'play reverse play reverse',
          start: `center bottom`, //When center of docItem reaches bottom of viewport
          end: `center top`, //When center of docItem reaches top of viewport
          scrub: true,
          toggleActions: "play reverse play reverse"
        }
      });
      tl
        .to(docItem, {opacity:1, duration:0.25})
        .to(docItem, {opacity:0.1, duration:0.25}, 0.95)
    }
}
